// extracted by mini-css-extract-plugin
module.exports = {"player-icon-mask":"eW","playerIconMask":"eW","player-icon-box":"eX","playerIconBox":"eX"};